import React from 'react';
import { Empty } from 'antd';
import EmployeeCensusPage from '../../pages/EmployeeCensusPage';

/**
 * Who is here now: Active Headcount by Team & App Job, in both its Summary and
 * Employee List views.
 *
 * App Job grouping is forced by the embedded page, since this tab is defined
 * as Team & App Job and the toggle that would change it is not shown.
 */
export default function CensusTab({ teamId, team }) {
  if (!teamId) {
    return <Empty description="Select a team" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <EmployeeCensusPage embedded teamId={teamId} sections={['byTeamJob']} />
    </>
  );
}
